import { AuthError } from 'aws-amplify/auth';
import { confirmSignUp, ConfirmSignUpInput } from '@aws-amplify/auth';
import { ConfirmSignUpSignUpStep } from '@aws-amplify/auth/src/types/models';

export const attemptConfirmSignUp = ({ username, confirmationCode }: ConfirmSignUpInput) =>
  confirmSignUp({
    username,
    confirmationCode,
  });

interface AuthConfirmSignUpProps {
  email: string;
  code: string;
}

const authConfirmSignUp = async ({ email, code }: AuthConfirmSignUpProps) => {
  try {
    const result = await attemptConfirmSignUp({ username: email, confirmationCode: code });
    const { signUpStep } = result.nextStep as ConfirmSignUpSignUpStep;

    return { success: result.isSignUpComplete, next: signUpStep };
  } catch (e) {
    if (e instanceof AuthError) {
      if (e.name === 'NotAuthorizedException' && e.message.match(/Current status .+ CONFIRMED/)) {
        return { success: false, reason: 'Already confirmed. Please try signing in or refreshing your browser' };
      }
    }

    if (!(e instanceof Error)) {
      // TODO: Log to rollbar
      return { success: false, reason: 'Unknown error' };
    }

    return { success: false, reason: e.message };
  }
};

export default authConfirmSignUp;
